(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyFormDataListController', CompanyFormDataListController);

    CompanyFormDataListController.$inject = ['$scope', 'ExportService', '$uibModalInstance', 'Principal', '$state', 'ReportService', '$translate', 'CustomerCustom', 'CompanyCustomerCustom'];

    function CompanyFormDataListController($scope, ExportService, $uibModalInstance, Principal, $state, ReportService, translate, CustomerCustom, CompanyCustomerCustom) {
        var vm = this;

        vm.selectedCustomer = null;
        vm.cancel = cancel;
        vm.confirm = confirm;
        vm.errorOnCreatingReport = false;
        vm.reportCreatedAndDownload = false;
        vm.errorOnCreatingReport = false;
        vm.showFormIsMandatory = false;

        vm.searchCustomer = function (query) {
            return CustomerCustom.searchCustomerBySearch(query).query();
        }

        vm.selectedCustomerChanged = function (selectedItem) {

            //if(selectedItem) {
            //
            //    var c = Customer.get({id:selectedItem.id});
            //    if (c != null) {
            //        vm.selectedCustomer = c;
            //    }
            //}
        };

        loadAll();

        function loadAll() {
            getAllCompanyCustomForms();
        }

        function confirm() {

            vm.showFormIsMandatory = false;

            vm.errorOnCreatingReport = true;
            vm.reportCreatedAndDownload = false;
            vm.errorOnCreatingReport = false;

            var customerId = 0;
            if (vm.selectedCustomer != null) {
                customerId = vm.selectedCustomer.id;
            }

            var formId = 0;
            if (vm.selectedCompanyCustomForm)
                formId = vm.selectedCompanyCustomForm;
            else {
                vm.showFormIsMandatory = true;
                return;
            }

            var file = ExportService.export_company_form_data_list(formId, customerId);
            ExportService.download_excel_file(file, onExportSuccess, onExportErrorr);


        }

        function onExportErrorr(error) {
            vm.errorOnCreatingReport = false;
            vm.reportCreatedAndDownload = false;
            vm.errorOnCreatingReport = true;
        }

        function onExportSuccess(result) {

            vm.errorOnCreatingReport = false;
            vm.reportCreatedAndDownload = true;
            vm.errorOnCreatingReport = false;
            vm.downloadlink = result.dllink;
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function getAllCompanyCustomForms() {
            CompanyCustomerCustom.getAllCompanyCustomForm().query(function (result) {
                vm.companyCustomForms = result;
            })
        }
    }
})();
